import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import 'moment-timezone';
import Card from "./bootstrap/Card";
import CardBlock from "./bootstrap/CardBlock";
import CardHeader from "./bootstrap/CardHeader";
import Container from "./bootstrap/Container";
import * as types from "../constants/actionTypes";
import AssignmentFileSubmissionFormLinks from "./AssignmentFileSubmissionFormLinks";
import AssignmentFileSubmission from "./AssignmentFileSubmission";
import { byteToMegabyte } from "../helpers/helpers";


class AssignmentFileSubmissionForm extends Component {
    constructor(props) {
        super(props);

        this.onDownloadFile = this.onDownloadFile.bind(this);
        this.onDropAssignmentFiles = this.onDropAssignmentFiles.bind(this);
        this.onRemoveFile = this.onRemoveFile.bind(this);

        const { assignment, dropbox } = this.props;

        const assignment_state = {
            ...assignment,
        };

        this.state = {
            errors: {},
            assignment: assignment_state,
            dropbox: dropbox
        };
    }

    onToggle(name, value) {
        this.setState({
            assignment: {
                ...this.state.assignment,
                [name]: value
            }
        });
    }

    checkFile(file) {
        /* global MAX_ASSIGNMENT_FILE_UPLOAD_SIZE */
        const regex = /^([A-Za-z0-9\-_ .]){1,255}$/,
            valid_file_name = (file.name).match(regex)
        ;

        if (!valid_file_name){
            this.props.dispatch({
                type: types.ADD_NOTIFICATION,
                payload: {
                    message: "Invalid file name.",
                    level: 'error'
                }
            });
            return false;
        }

        if (file.size > MAX_ASSIGNMENT_FILE_UPLOAD_SIZE) {
            let message = "File size exceeded limit of: " +
                byteToMegabyte(MAX_ASSIGNMENT_FILE_UPLOAD_SIZE)
            ;
            this.props.dispatch({
                type: types.ADD_NOTIFICATION,
                payload: {
                    message: message,
                    level: 'error'
                }
            });
            return false;
        }

        if (file.size <= 0) {
            this.props.dispatch({
                type: types.ADD_NOTIFICATION,
                payload: {
                    message: "File must not be empty",
                    level: 'error'
                }
            });
            return false;
        }

        return true;
    }

    onDropFiles(files, fixedName) {
        let { assignment } = this.props;

        _.map(files, (file) => {
            let assignment_filename = _.head(
                _.filter(
                    assignment.assignment_filenames,
                    {
                        name: file.name
                    }
                )
            );

            if (this.checkFile(file)) {
                let assignment_filename_id = (fixedName === true)
                    ? parseInt(assignment_filename.id)
                    : null
                ;

                this.props.dispatch({
                    type: types.ASSIGNMENT__FILE__UPLOAD__REQUESTED,
                    payload: {
                        file: file,
                        assignment: assignment.id,
                        assignment_updated: assignment.updated,
                        assignment_filename_id: assignment_filename_id
                    }
                });
            }
        });
    }

    onDropAssignmentFiles(files) {
        this.onDropFiles(files, false);
    }

    onDownloadFile(event) {
        event.preventDefault();
        let file_id = event.target.id;
        let file_name = event.target.attributes.getNamedItem('name').value;
        let file_size = event.target.attributes.getNamedItem('size').value;

        this.props.dispatch({
            type: types.ASSIGNMENT__FILE__DOWNLOAD__REQUESTED,
            payload: {
                file_id : parseInt(file_id),
                file_name : file_name,
                file_size : parseInt(file_size)
            }
        });
    }

    onRemoveFile(event) {
        event.preventDefault();
        let file_id = event.target.id;

        this.props.dispatch({
            type: types.ASSIGNMENT__FILE__DELETE__REQUESTED,
            payload: {
                file_id : parseInt(file_id)
            }
        });
    }

    render() {
        if (!this.state || !this.state.assignment || this.state.assignment.name === undefined) {
            return null;
        }

        const { assignment, className, dropbox } = this.props;

        return dropbox
            ? (
                <div className="table-responsive">
                    <AssignmentFileSubmissionFormLinks
                        dropbox={dropbox}
                        assignment={assignment}
                        handleExit={this.handleExit}
                    />
                    <Container
                        title={dropbox.name + ': ' + assignment.name}
                        className={className}
                    >
                        <CardBlock>
                            <Card>
                                <CardBlock className={"alert-warning"}>
                                    Upload Assignment Files that will be made available for students to download. <br/>
                                    Do not upload private assignment solutions or other files that you do not want the students to download.
                                </CardBlock>
                            </Card>
                            <form className="border-top-0">
                                <Card>
                                    <CardHeader className="bg-primary">Assignment Files</CardHeader>
                                    <AssignmentFileSubmission
                                        onDropAssignmentFile={this.onDropAssignmentFiles}
                                        label={'Assignment Files'}
                                        assignment={assignment}
                                        onDownloadFile={this.onDownloadFile}
                                        onRemoveFile={this.onRemoveFile}
                                        disabled={null}
                                    />
                                </Card>
                            </form>
                        </CardBlock>
                    </Container>
                </div>
            ) : null
        ;
    }
}

AssignmentFileSubmissionForm.propTypes = {
    assignment: PropTypes.object.isRequired,
    assignments: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    dropbox: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    uploadAllowed: PropTypes.bool
};

function mapStateToProps(state) {
    const { assignment, assignments, auth, request } = state;

    return { assignment, assignments, auth, request };
}

export default connect(mapStateToProps)(AssignmentFileSubmissionForm);



/** WEBPACK FOOTER **
 ** ./src/components/AssignmentFileSubmissionForm.js
 **/